const clone = (value) => JSON.parse(JSON.stringify(value));

const merge = (target, incoming) => {
  if (!incoming || typeof incoming !== "object") return target;
  Object.keys(incoming).forEach((key) => {
    if (!(key in target)) return;
    const current = target[key];
    const next = incoming[key];
    if (Array.isArray(current) && Array.isArray(next)) {
      current.forEach((item, index) => {
        if (index >= next.length) return;
        if (item && typeof item === "object") merge(item, next[index]);
        else if (typeof next[index] === typeof item) current[index] = next[index];
      });
    } else if (current && typeof current === "object" && next && typeof next === "object") {
      merge(current, next);
    } else if (typeof next === typeof current) {
      target[key] = next;
    }
  });
  return target;
};

const sharedService = (title) => ({
  eyebrow: "مجال الخدمة",
  form: {
    eyebrow: "طلب مباشر",
    heading: `طلب بخصوص ${title}`,
    subtitle: "اشرح لنا طلبك وسنتواصل معك في أقرب وقت.",
  },
});

const ARABIC_OVERRIDES = {
  global: {
    site: {
      slogan: "شريككم من الألف إلى الياء",
      tagline: "كل الخدمات من مصدر واحد",
      region: "شمال الراين-وستفاليا",
      regionShort: "NRW",
      address: { region: "شمال الراين-وستفاليا، ألمانيا" },
    },
    hotlines: [
      { label: "هاتف الخبرة وتسجيل المركبات" },
      { label: "هاتف التأمين" },
      { label: "المكتب" },
    ],
    openingHours: [
      { days: "الاثنين – الجمعة", time: "08:00 – 18:00" },
      { days: "السبت", time: "12:00 – 19:00" },
    ],
    navLinks: [
      { label: "الرئيسية" },
      { label: "من نحن" },
      { label: "شبكة الشركاء" },
      { label: "اتصل بنا" },
    ],
    categories: [
      { label: "تقييم أضرار المركبات" },
      { label: "التأمين" },
      { label: "تسجيل المركبات" },
      { label: "الخدمات" },
      { label: "استفسار عام" },
    ],
    services: [
      {
        title: "تقييم المركبات",
        short: "تقارير احترافية للمركبات وتقييم القيمة ومرافقة كاملة في معالجة الأضرار.",
        description: "نعد تقارير احترافية لأضرار المركبات وتقييمات للقيمة وتوثيقاً كاملاً للحوادث، ونرافقكم بثقة خلال جميع مراحل معالجة الضرر.",
        bullets: ["تقرير أضرار بعد الحادث", "تقييم قيمة المركبة", "توثيق كامل للحادث", "مرافقة معالجة الضرر بالكامل"],
        alt: "خبير يوثق أضرار مركبة",
      },
      {
        title: "التأمين",
        short: "جميع أنواع التأمين مع مراجعة العقود الحالية وتحسينها بشفافية.",
        description: "نراجع عقود التأمين الحالية بعناية ونحلل فرص التحسين ونبحث لكم بشفافية عن حلول أفضل، لتدفعوا ما يلزم فقط مع حماية شاملة.",
        bullets: ["جميع أنواع التأمين من مصدر واحد", "مراجعة العقود الحالية", "تحليل فرص التحسين", "البحث الشفاف عن حلول أفضل"],
        alt: "استشارة تأمين شخصية في المكتب",
      },
      {
        title: "تسجيل المركبات",
        short: "تسجيل المركبة والمعاملات والوثائق بسهولة ومن دون تعقيد.",
        description: "نتولى تسجيل المركبات ونساعدكم في جميع الإجراءات ونجهز الوثائق المطلوبة، لتصبح المعاملة أسرع وأسهل من دون انتظار أو أوراق معقدة.",
        bullets: ["تسجيل ونقل وإلغاء تسجيل المركبات", "المساعدة في جميع الإجراءات", "تجهيز جميع الوثائق", "إنجاز سريع ومبسّط"],
        alt: "توقيع وثائق المركبة",
      },
      {
        title: "الخدمات",
        short: "متابعة العقود والخدمات اليومية، بما فيها عقود الكهرباء والغاز.",
        description: "نرافقكم في شؤون العقود والخدمات اليومية، من الكهرباء والغاز إلى تحسين العقود الحالية، ونوفر عليكم الوقت والمال والجهد.",
        bullets: ["عقود الكهرباء والغاز", "تحسين العقود الحالية", "متابعة العقود والخدمات", "مرافقة شخصية طويلة الأمد"],
        alt: "مستشارة تراجع العقود مع العملاء",
      },
    ],
    benefits: [
      { title: "كل شيء من مصدر واحد", text: "التأمين والتقييم والتسجيل والعقود لدى جهة اتصال واحدة." },
      { title: "استشارة شفافة", text: "توصيات واضحة ومفهومة في كل خطوة." },
      { title: "إنجاز سريع", text: "نتولى المعاملات بسرعة لتوفير وقتكم." },
      { title: "حماية البيانات والسرية", text: "نتعامل مع بياناتكم وطلباتكم بسرية وأمان." },
      { title: "توفير التكاليف", text: "نراجع فرص التحسين باستمرار حتى لا تدفعوا أكثر من اللازم." },
      { title: "متابعة طويلة الأمد", text: "نبقى إلى جانبكم بشكل شخصي وموثوق." },
    ],
    reviews: {
      items: [
        { city: "دوسلدورف", text: "بعد الحادث اهتمت AZ Gruppe بكل شيء: التقرير والتأمين والمعاملات. خدمة موثوقة وشخصية للغاية." },
        { city: "كولن", text: "أخيراً جهة اتصال واحدة لكل شيء. تمت مراجعة عقودي وأصبحت أوفر شهرياً. استشارة شفافة جداً." },
        { city: "إيسن", text: "تم تسجيل المركبة بلا أي توتر. سريع وودود وسهل. أوصي بهم بالتأكيد." },
        { city: "دورتموند", text: "فريق كفؤ وصادق، وكل الخدمات من مصدر واحد. أشعر أنني في أيدٍ أمينة." },
      ],
    },
    socialLinks: [
      { label: "فيسبوك" }, { label: "إنستغرام" }, { label: "تيك توك" }, { label: "البريد الإلكتروني" },
      { label: "واتساب التسجيل والتقييم" }, { label: "واتساب التأمين والطاقة" },
    ],
  },
  home: {
    homeStatement: {
      eyebrow: "ما الذي يحفزنا",
      title: "كل شيء من مصدر واحد وباهتمام شخصي.",
      text: "نفكر في الحلول لا في تقسيم المسؤوليات. التأمين والتقييم والتسجيل والعقود تعمل لدينا معاً، لتحتاجوا إلى جهة اتصال واحدة فقط.",
      alt: "مبنى مكتبي حديث يرمز إلى التعاون الموثوق",
    },
    homeShowcase: [
      {
        eyebrow: "لماذا AZ Gruppe",
        title: "شريك موثوق من الألف إلى الياء.",
        text: "لسنا مجرد وسيط. نهتم بطلباتكم بأنفسنا ونراجعها بعناية ونحافظ على مصالحكم، بمتابعة شفافة وشخصية طويلة الأمد.",
        bullets: ["جهة اتصال واحدة لجميع المجالات", "استشارة شفافة وصادقة", "متابعة شخصية من دون انتظار", "تحسين دوري لعقودكم"],
        alt: "فريق AZ Gruppe في جلسة استشارة",
        stat: { label: "جهة اتصال لكل شيء" },
      },
      {
        eyebrow: "متابعة شخصية",
        title: "نربط الناس ونحل الطلبات.",
        text: "وراء كل استفسار شخص لديه حاجة واضحة. لذلك نعتمد طرقاً قصيرة وتواصلاً واضحاً وفريقاً يستمع ويتصرف بموثوقية.",
        bullets: ["رد سريع على استفساركم", "شرح واضح من دون مصطلحات معقدة", "تعامل سري مع بياناتكم", "مرافقة طويلة الأمد حتى بعد إتمام الخدمة"],
        alt: "جلسة استشارة شخصية في مكتب AZ Gruppe",
        stat: { label: "متابعة شخصية" },
      },
    ],
    homeVideo: {
      eyebrow: "AZ Gruppe في حركة",
      title: "شريك واحد لكل الطرق.",
      text: "من الاستشارة الأولى حتى إتمام المعاملة نرافقكم شخصياً وبهدوء وموثوقية مع الاهتمام بكل التفاصيل.",
      caption: "استشارة ومتابعة شخصية",
    },
    homeStats: [
      { label: "مجالات الخدمة", hint: "التقييم · التأمين · التسجيل · الخدمات" },
      { label: "تقييمات Google", hint: "من عملاء راضين" },
      { label: "متوسط التقييم", hint: "للخدمة والموثوقية" },
      { label: "جهة اتصال", hint: "كل شيء من مصدر واحد" },
    ],
    page: {
      servicesHeading: { eyebrow: "خدماتنا", title: "كل شيء في مكان واحد من أجلكم.", subtitle: "اختاروا المجال الذي تحتاجونه وسنهتم شخصياً بالباقي." },
      benefitsHeading: { eyebrow: "مزاياكم", title: "لماذا يثق بنا العملاء؟" },
      contact: {
        eyebrow: "تواصلوا معنا", title: "نحن هنا من أجلكم.",
        subtitle: "أرسلوا لنا رسالة وسنتواصل معكم شخصياً بأسرع وقت، أو اتصلوا بنا مباشرة.",
        phoneLabel: "الهاتف", emailLabel: "البريد الإلكتروني", formTitle: "استفسار سريع",
        formSubtitle: "خلال ثوانٍ وسنتصل بكم.", submitLabel: "إرسال الرسالة",
      },
    },
  },
  pages: {
    about: {
      hero: { eyebrow: "AZ Gruppe", title: "من نحن", subtitle: "AZ Gruppe شريككم الموثوق لخدمات المركبات الاحترافية في إيسن.", alt: "استشارة شخصية لدى AZ Gruppe" },
      contentImage: { alt: "منطقة الاستقبال في AZ Gruppe بمدينة إيسن" },
      paragraphs: [
        "نساعد الأفراد ومعارض السيارات وشركات التأجير والمؤسسات بحلول سريعة وشخصية وموثوقة في تسجيل المركبات والتقييم والخدمات الأخرى.",
        "بفضل اتصالنا المباشر بنظام التسجيل الإلكتروني لمدينة إيسن يمكن إنجاز العديد من معاملات التسجيل بسرعة وكفاءة ومن دون انتظار طويل.",
        "بواسطة آلة طباعة اللوحات الخاصة بنا تحصلون على لوحاتكم مباشرة في الموقع ومن دون مشاوير إضافية.",
        "سواء كان تسجيل مركبة أو نقلها أو إلغاء تسجيلها أو إصدار لوحة مؤقتة أو لوحة تصدير أو لوحة مميزة، نتولى المعاملة بموثوقية وبشكل شخصي.",
      ],
      servicesHeading: "تشمل خدماتنا على سبيل المثال:",
      services: ["تسجيل المركبات", "نقل تسجيل المركبات", "إلغاء التسجيل", "لوحات مؤقتة", "لوحات التصدير", "لوحات مميزة", "استبدال وثائق المركبة", "طباعة اللوحات مباشرة في الموقع"],
      gallery: [
        { alt: "استشارة شخصية لدى AZ Gruppe" }, { alt: "مكان عمل AZ Gruppe" }, { alt: "فريق AZ Gruppe" }, { alt: "مقر AZ Gruppe" },
      ],
      cta: {
        eyebrow: "سريع · كفؤ · موثوق", text: "جهة اتصال واحدة لجميع خدمات مركبتكم.",
        highlight: "كل شيء من مصدر واحد.", contactButton: "تواصلوا معنا", phoneButton: "اتصلوا بنا",
      },
    },
    partner: {
      hero: {
        alt: "فريق AZ Gruppe في جلسة استشارة", eyebrow: "شبكة الشركاء",
        title: "مجالات خدماتنا من مصدر واحد.",
        subtitle: "لسنا مجرد وسيط. نهتم بطلباتكم بأنفسنا بموثوقية وشفافية. اختاروا المجال لمعرفة المزيد.",
      },
      heading: {
        eyebrow: "مجالات الخدمات", title: "أربعة مجالات وجهة اتصال واحدة.",
        subtitle: "لكل مجال صفحة مستقلة بمعلومات وصور مفصلة. اضغطوا على معرفة المزيد.",
      },
    },
    contact: {
      hero: { eyebrow: "اتصل بنا", title: "لنتحدث.", subtitle: "سواء تعلق الأمر بالتقييم أو التأمين أو تسجيل المركبات أو العقود، نحن هنا لتقديم استشارة شخصية." },
      details: {
        title: "طرق التواصل معنا", subtitle: "اتصلوا بأحد أرقامنا أو أرسلوا بريداً إلكترونياً أو استخدموا النموذج. يسعدنا استقبال طلبكم.",
        emailLabel: "البريد الإلكتروني", addressLabel: "العنوان", hoursLabel: "ساعات العمل",
      },
      social: { title: "طرق التواصل معنا", subtitle: "اختاروا وسيلة التواصل المناسبة، نحن سعداء بخدمتكم." },
      form: { title: "إرسال استفسار", subtitle: "املؤوا النموذج وسنتواصل معكم شخصياً بأسرع وقت.", submitLabel: "إرسال الاستفسار" },
    },
  },
  servicePages: {
    gutachten: {
      ...sharedService("تقييم المركبات"),
      title: "تقييم أضرار المركبات", intro: "تقارير مستقلة وتقييم واضح ودعم احترافي في حالات الضرر.",
      detail: {
        heading: "خبيركم المستقل للمركبات",
        paragraphs: [
          "AZ Gruppe هي جهة اتصالكم المختصة لإعداد تقارير المركبات الاحترافية في إيسن والمناطق المحيطة.",
          "يعد خبراؤنا المعتمدون تقارير مستقلة ومتخصصة للأفراد والشركات ومعارض السيارات.",
          "بعد الحوادث أو لتقييم المركبة أو حفظ الأدلة، نقف إلى جانبكم بخبرة وتقييم موضوعي.",
          "نرافقكم خلال العملية كاملة ونشرح كل خطوة بوضوح ونساعدكم في معالجة الضرر.",
        ],
      },
      media: { eyebrow: "لمحات", heading: "نظرة على عملنا", subtitle: "تقييم احترافي واستشارة شخصية ومعالجة موثوقة للأضرار." },
      benefits: {
        eyebrow: "مزاياكم", heading: "مزاياكم بنظرة واحدة",
        items: [
          { title: "خبراء مركبات معتمدون", text: "خبراء مؤهلون بخبرة راسخة واعتماد مهني." },
          { title: "تقرير مستقل", text: "تقييم محايد وموضوعي يراعي مصالحكم فقط." },
          { title: "مواعيد سريعة", text: "مواعيد قصيرة المدى وفي موقعكم عند الطلب." },
          { title: "متابعة شخصية", text: "جهة اتصال ثابتة ترافقكم طوال العملية." },
          { title: "دعم معالجة الضرر", text: "نساعد في التواصل مع التأمين والورشة والمحامي." },
          { title: "للأفراد والشركات", text: "تقارير للأفراد والشركات ومعارض السيارات." },
        ],
      },
      scope: {
        eyebrow: "خدمة متكاملة", heading: "خدمتنا المتكاملة ودعم من الألف إلى الياء", subtitle: "جهة اتصال واحدة، تقييم واضح، وإنجاز سريع.",
        items: ["تقرير حادث وحفظ الأدلة", "التعامل المباشر مع شركة التأمين", "خدمة السحب", "مركبة بديلة", "ورش شريكة", "محامون مختصون بقانون المرور", "مراعاة خسارة الاستخدام وانخفاض القيمة وفقدان الدخل", "مواعيد سريعة في موقعكم", "خدمة في جميع أنحاء ألمانيا"],
      },
      cta: { eyebrow: "اتصل بنا", heading: "ضرر في المركبة أو تحتاجون إلى تقرير؟ لا مشكلة.", text: "نعد تقارير احترافية بسرعة واستقلالية وموثوقية، ونرافقكم من المعاينة الأولى حتى التقرير النهائي." },
    },
    versicherung: {
      ...sharedService("التأمين"),
      title: "التأمين", intro: "مستقلون، شخصيون، وإلى جانبكم.",
      highlights: ["أكثر من 750 شريكاً", "خدمة في جميع ألمانيا", "استشارة مستقلة", "متابعة شخصية"],
      detail: { heading: "شريككم المستقل في ألمانيا", paragraphs: ["نقارن لكم عروض أكثر من 750 شريكاً في التأمين والتمويل والطاقة والتقاعد.", "وبذلك تحصلون على الحل المناسب لكم فعلاً، لا على عرض شركة واحدة فقط."] },
      media: { eyebrow: "لمحات", heading: "استشارة شخصية تناسبكم" },
      benefits: {
        eyebrow: "", heading: "مستقلون، شخصيون، وواضحون.",
        items: [
          { title: "مستقلون", text: "لا نعمل لصالح شركة تأمين، بل لصالح عملائنا، ونقارن أكثر من 750 شريكاً." },
          { title: "شخصيون", text: "جهة اتصال ثابتة لجميع المواضيع والأسئلة." },
          { title: "واضحون", text: "جميع عقودكم أمامكم بشفافية وتحكم وأمان أكبر." },
        ],
      },
      scope: { eyebrow: "", heading: "لديكم عقود حالية؟ لا مشكلة.", subtitle: "بغض النظر عن الشركة الحالية، يمكننا استلام متابعة عقودكم لنصبح جهة الاتصال المركزية.", items: ["جمع العقود وتوضيحها", "اكتشاف فرص التحسين", "متابعة واستشارة شخصية", "الدعم عند حدوث ضرر"] },
      steps: {
        eyebrow: "الأمر بهذه السهولة", heading: "أربع خطوات لمزيد من الأمان والتوفير",
        items: [
          { title: "استشارة مجانية", text: "نتعرف إلى وضعكم واحتياجاتكم وأهدافكم." },
          { title: "تحليل", text: "نراجع العقود الحالية ونحلل مستوى الحماية." },
          { title: "مقارنة", text: "نقارن العروض المناسبة من بين أكثر من 750 شريكاً." },
          { title: "متابعة", text: "نرافقكم على المدى الطويل ونقف إلى جانبكم عند الضرر." },
        ],
      },
      cta: {
        eyebrow: "AZ Gruppe", heading: "شريككم من الألف إلى الياء",
        text: "نرافق الأفراد والشركات في التأمين والتمويل والطاقة والتقاعد بشفافية واستقلالية واهتمام شخصي.",
        points: [
          { title: "مقرنا في إيسن", text: "نخدمكم في جميع أنحاء ألمانيا." },
          { title: "أكثر من 750 شريكاً", text: "وصول إلى شبكة قوية." },
          { title: "جهة اتصال واحدة", text: "لجميع المواضيع المتعلقة بعقودكم." },
          { title: "خدمة الأضرار", text: "لا نترككم وحدكم عند الحاجة." },
        ],
      },
    },
    "kfz-zulassung": {
      ...sharedService("تسجيل المركبات"),
      title: "تسجيل المركبات", intro: "تسجيل المركبة والوثائق والإجراءات بسهولة وسرعة.",
      detail: {
        heading: "تسجيل مركبتكم بسرعة ومن دون تعقيد",
        paragraphs: [
          "تتولى AZ Gruppe تسجيل المركبة ونقلها وإلغاء تسجيلها بالكامل، لتوفروا وقت الانتظار والدوائر الرسمية والمعاملات الورقية.",
          "نجهز جميع الوثائق ونطبع اللوحات ونتولى الإجراءات بموثوقية للأفراد ومعارض السيارات والشركات.",
          "وعند الطلب ننجز التسجيل رقمياً وفي جميع أنحاء ألمانيا لتصبح مركبتكم جاهزة بأسرع وقت.",
        ],
      },
      media: { eyebrow: "لمحات", heading: "كل ما يتعلق بتسجيل مركبتكم", subtitle: "اللوحات والوثائق والإجراءات من مصدر واحد وبموثوقية." },
      benefits: {
        eyebrow: "مزاياكم", heading: "مزاياكم بنظرة واحدة",
        items: [
          { title: "التسجيل والنقل والإلغاء", text: "نتولى جميع أنواع التسجيل للمركبات الجديدة والمستعملة وتغيير المالك." },
          { title: "جميع الإجراءات مشمولة", text: "نهتم بكل خطوة من رقم التأمين حتى الملصق البيئي." },
          { title: "وثائق جاهزة", text: "نجمع جميع الأوراق المطلوبة ونتحقق من اكتمالها." },
          { title: "طباعة اللوحات", text: "تحصلون على اللوحات مباشرة لدينا من دون مشوار إضافي." },
          { title: "إنجاز سريع", text: "مدة معالجة قصيرة لتسجيل المركبة من دون تأخير." },
          { title: "خدمة في جميع ألمانيا", text: "نتولى التسجيل رقمياً وعلى مستوى ألمانيا عند الطلب." },
        ],
      },
      cta: { eyebrow: "اتصل بنا", heading: "تسجيل المركبة أو نقلها؟ لا مشكلة.", text: "نتولى التسجيل كاملاً مع جميع الوثائق واللوحات بسرعة وموثوقية ومن دون أوراق معقدة عليكم." },
    },
    services: {
      ...sharedService("الخدمات"),
      title: "الخدمات", intro: "متابعة العقود والخدمات اليومية، بما فيها الكهرباء والغاز.",
      detail: {
        heading: "العقود والخدمات مجمعة بذكاء",
        paragraphs: [
          "ترافقكم AZ Gruppe في شؤون العقود والخدمات اليومية، من الكهرباء والغاز إلى تحسين العقود الحالية.",
          "نقارن المزودين ونكشف فرص التوفير ونتولى التغيير، لتوفروا الوقت والمال والجهد.",
          "وبصفتنا شريكاً طويل الأمد نتابع عقودكم ونبلغكم عند توفر حل أفضل.",
        ],
      },
      benefits: {
        eyebrow: "مزاياكم", heading: "مزاياكم بنظرة واحدة",
        items: [
          { title: "عقود الكهرباء والغاز", text: "نجد التعرفة المناسبة ونتولى الانتقال كاملاً." },
          { title: "تحسين العقود", text: "نراجع العقود الحالية دورياً ونحسنها عند الحاجة." },
          { title: "متابعة العقود والخدمات", text: "جهة اتصال واحدة لعقودكم اليومية." },
          { title: "اكتشاف فرص التوفير", text: "نقارن المزودين ونوضح أين يمكنكم التوفير." },
          { title: "مرافقة طويلة الأمد", text: "نبقى إلى جانبكم ونحسن عقودكم باستمرار." },
          { title: "شخصيون وموثوقون", text: "جهة اتصال ثابتة واستشارة واضحة من دون انتظار." },
        ],
      },
      cta: { eyebrow: "اتصل بنا", heading: "تحسين العقود أو تغييرها؟ لا مشكلة.", text: "نقارن المزودين ونكشف فرص التوفير ونتولى التغيير بشفافية واهتمام شخصي ومن دون جهد منكم." },
    },
  },
  common: {
    hero: {
      headline: "شريككم من الألف إلى الياء.", subtitle: "نظام واحد للتأمين والتقييم والعقود وخدمات المركبات بموثوقية واهتمام شخصي ومن مصدر واحد.",
      phoneButton: "اتصلوا بنا", contactButton: "تواصلوا معنا",
    },
    hotlines: { eyebrow: "اتصال مباشر", title: "أرقام التواصل بنظرة واحدة", subtitle: "تواصلوا مباشرة مع القسم المناسب، نحن هنا لخدمتكم شخصياً." },
    reviews: { eyebrow: "تقييمات Google", title: "ماذا يقول عملاؤنا؟", closing: "شكراً لثقتكم." },
    footer: {
      description: "نظام واحد للتأمين والتقييم والعقود وخدمات المركبات بموثوقية واهتمام شخصي ومن مصدر واحد.",
      navigationTitle: "التنقل", servicesTitle: "الخدمات", contactTitle: "التواصل", socialTitle: "تابعونا",
      rights: "جميع الحقوق محفوظة.", developer: "تطوير BAYAN NETZ",
    },
    navbar: { phoneButton: "اتصلوا بنا", contactButton: "تواصلوا معنا", socialTitle: "تابعونا", emailButton: "إرسال بريد" },
    form: {
      nameLabel: "الاسم", namePlaceholder: "اسمكم", emailLabel: "البريد الإلكتروني", emailPlaceholder: "name@example.de",
      phoneLabel: "الهاتف", optionalLabel: "(اختياري)", phonePlaceholder: "+49 …",
      categoryLabel: "مجال الطلب", categoryPlaceholder: "يرجى الاختيار", messageLabel: "الرسالة", messagePlaceholder: "كيف يمكننا مساعدتكم؟",
      sendingLabel: "جارٍ الإرسال…", consent: "بإرسال النموذج توافقون على معالجة بياناتكم للرد على طلبكم.",
      successTitle: "شكراً لاستفساركم!", successText: "وصلتنا رسالتكم وسيتواصل فريقنا معكم شخصياً بأسرع وقت.",
      resetButton: "إرسال استفسار آخر", nameError: "يرجى إدخال الاسم.", emailError: "يرجى إدخال بريد إلكتروني صحيح.", messageError: "يرجى كتابة رسالة قصيرة.",
    },
    service: { detailEyebrow: "التفاصيل", phoneButton: "اتصلوا بنا", contactButton: "تواصلوا معنا", emailButton: "إرسال بريد", submitLabel: "إرسال الاستفسار" },
  },
};

export const getArabicCmsContent = (germanDefaults) => merge(clone(germanDefaults), ARABIC_OVERRIDES);
